export enum HeaderTypeEnum {
    String = 'string',
    Boolean = 'boolean',
    Numeric = 'numeric',
    Array = 'array',
    Date = 'Date'
}